import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import "../../styles/ConsultantEvaluation.css";
import PageLoder from '../../components/PageLoader';

export default function ConsultantEvaluationList() {
     const getProfileEmpCode = () => {
          try {
               const raw = sessionStorage.getItem('userProfile') || localStorage.getItem('userProfile');
               if (raw) {
                    const profile = JSON.parse(raw);
                    return profile.employee_code || profile.emp_code || profile.user_code || sessionStorage.getItem('user_code') || localStorage.getItem('user_code') || '';
               }
          } catch (e) {
               // ignore parse errors
          }
          return sessionStorage.getItem('user_code') || localStorage.getItem('user_code') || '';
     };

     const [empCode, setEmpCode] = useState(getProfileEmpCode());
     const [quarter, setQuarter] = useState("");
     const currentYear = new Date().getFullYear();
     const [year, setYear] = useState(currentYear.toString());
     const [evaluations, setEvaluations] = useState([]);
     const [currentPage, setCurrentPage] = useState(1);
     const [pageSize, setPageSize] = useState(10);
     const [loading, setLoading] = useState(false);
     const [message, setMessage] = useState(null);
     const baseUrl = process.env.REACT_APP_BASE_URL;

     const fetchEvaluations = async (code = "", q = "", y = currentYear.toString()) => {
          setMessage(null);
          setLoading(true);
          try {
               const token = localStorage.getItem("token");
               const headers = { Accept: "application/json" };
               if (token) headers["Authorization"] = `Bearer ${token}`;

               const params = new URLSearchParams();
               if (code && code.toString().trim() !== "") params.set('emp_code', code.toString().trim());
               if (q && q.toString().trim() !== "") params.set('quarter', q.toString().trim());
               if (y && y.toString().trim() !== "") params.set('year', y.toString().trim());

               const url = `${baseUrl}/getSelfEvaluationsListByFilter?${params.toString()}`;
               const res = await fetch(url, { method: "GET", headers });
               const json = await res.json();
               if (res.ok) {
                    const list = Array.isArray(json) ? json : [];
                    setEvaluations(list);
                    setCurrentPage(1);
               } else {
                    console.error(json);

               }
          } catch (err) {
               console.error(err);

          } finally {
               setLoading(false);
          }
     };

     const navigate = useNavigate();

     const quarterLabel = (q) => {
          if (!q) return '';
          switch (q.toString().toUpperCase()) {
               case 'Q1': return 'Jan - Mar';
               case 'Q2': return 'Apr - Jun';
               case 'Q3': return 'Jul - Sep';
               case 'Q4': return 'Oct - Dec';
               default: return q;
          }
     };

     const handleDelete = async (id) => {
          if (!window.confirm('Delete this evaluation? ')) return;
          setLoading(true);
          try {
               const token = localStorage.getItem('token');
               const headers = { Accept: 'application/json' };
               if (token) headers['Authorization'] = `Bearer ${token}`;

               const url = `${baseUrl}/deleteConsultantEvaluation/${id}`;
               const res = await fetch(url, { method: 'DELETE', headers });
               const json = await res.json();
               if (res.ok) {
                    // remove from state
                    setEvaluations(prev => prev.filter(ev => ev.id !== id));
                    setMessage({ type: 'success', text: json.message || 'Deleted' });
               } else {
                    setMessage({ type: 'error', text: json.error || JSON.stringify(json) });
               }
          } catch (err) {
               console.error(err);
               setMessage({ type: 'error', text: 'Delete request failed' });
          } finally {
               setLoading(false);
          }
     };

     const handleSearch = (e) => {
          e && e.preventDefault();
          fetchEvaluations(empCode, quarter, year);
     };

     useEffect(() => {
          // fetch evaluations for current year on load (use profile empCode if present)
          fetchEvaluations(empCode || "", "", currentYear.toString());
     }, []);

     // trigger search when filters change (debounced)
     useEffect(() => {
          const t = setTimeout(() => {
               fetchEvaluations(empCode, quarter, year);
          }, 350);
          return () => clearTimeout(t);
     }, [empCode, quarter, year]);

     const totalPages = Math.max(1, Math.ceil(evaluations.length / pageSize));

     useEffect(() => {
          if (currentPage > totalPages) setCurrentPage(totalPages);
     }, [evaluations, pageSize, totalPages]);

     const startIndex = (currentPage - 1) * pageSize;
     const endIndex = Math.min(startIndex + pageSize, evaluations.length);
     const pagedEvaluations = evaluations.slice(startIndex, endIndex);

     const exportEvaluationsCSV = (filename = `consultant_evaluations_${year || 'all'}.csv`) => {
          if (!evaluations || evaluations.length === 0) {
               setMessage({ type: 'error', text: 'No data to export' });
               return;
          }
          const headers = ['Emp Code', 'Name', 'Quarter', 'Year', 'Centre', 'Total Points', 'Submitted'];
          const rows = evaluations.map(ev => [
               ev.emp_code || '',
               ev.emp_name || ev.comp_name || '',
               quarterLabel(ev.quarter),
               ev.year || '',
               ev.centre || '',
               ev.total_points != null ? ev.total_points : '',
               ev.is_submitted === 'Y' ? 'Yes' : 'No'
          ]);

          const escapeCell = (cell) => {
               if (cell === null || cell === undefined) return '';
               const s = cell.toString();
               // escape double quotes
               return `"${s.replace(/"/g, '""')}"`;
          };

          const csvContent = [headers, ...rows].map(r => r.map(escapeCell).join(',')).join('\r\n');

          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
     };



     return (
          <div className="consultant-eval">
               <div className="row" >
                    <div className="col-sm-3">
                         <h2>Consultant Evaluations</h2>

                    </div>
                    <div className="col-sm-12">
                         {message && (
                              <div style={{ margin: '8px 0' }} className={message.type === 'error' ? 'alert alert-danger' : 'alert alert-success'}>
                                   {message.text}
                              </div>
                         )}
                    </div>
                    <div className="col-sm-6" >
                         <form onSubmit={handleSearch} className="search-row" style={{ marginBottom: 12 }}>
                              {/* Employee Code input removed — defaulting to profile emp code */}
                              <label >
                                   <span style={{ paddingLeft: 10 }}>  Quarter</span>
                                   <select value={quarter} onChange={(e) => setQuarter(e.target.value)} style={{ marginLeft: 8 }}>
                                        <option value="">Any</option>
                                        <option value="Q1">Jan - Mar</option>
                                        <option value="Q2">Apr - Jun</option>
                                        <option value="Q3">Jul - Sep</option>
                                        <option value="Q4">Oct - Dec</option>
                                   </select>
                              </label>
                              <label>
                                   <span style={{ paddingLeft: 10 }}> Year</span>
                                   <select value={year} onChange={(e) => setYear(e.target.value)} style={{ marginLeft: 8 }}>
                                        <option value={currentYear.toString()}>{currentYear}</option>
                                        <option value={(currentYear - 1).toString()}>{currentYear - 1}</option>
                                        <option value="">Any</option>
                                   </select>
                              </label>
                              {/* Search is triggered automatically when filters change */}
                              <label style={{ marginLeft: 8 }}>
                                   <span style={{ paddingLeft: 10 }}>  Page size</span>
                                   <select value={pageSize} onChange={(e) => { setPageSize(parseInt(e.target.value, 10)); setCurrentPage(1); }} style={{ marginLeft: 8 }}>
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                   </select>
                              </label>

                         </form>
                    </div>
                    <div className="col-sm-3" style={{ textAlign: "right" }}>
                         <button className="btn" onClick={() => navigate('/create-self-evaluation')} style={{ marginRight: 8 }}>Add New</button>
                         <button className="btn" onClick={() => exportEvaluationsCSV()} style={{ marginRight: 8 }}>Export CSV</button>
                    </div>
               </div>
               <div>
                    {loading ? (
                         <div className="text-center py-4"><PageLoder /></div>
                    ) : evaluations.length === 0 ? (
                         <div>No evaluations to show.</div>
                    ) : (
                         <>
                              <table className="eval-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                                   <thead>
                                        <tr>
                                             <th>Sr. No</th>
                                             <th>Emp Code</th>
                                             <th>Name</th>
                                             <th>Quarter</th>
                                             <th>Year</th>
                                             <th>Centre</th>
                                             <th>Total Points</th>
                                             <th>Submitted</th>
                                             <th>Actions</th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {pagedEvaluations.map((ev, idx) => (
                                             <tr key={ev.id || startIndex + idx}>
                                                  <td>{startIndex + idx + 1}</td>
                                                  <td>{ev.emp_code}</td>
                                                  <td>{ev.emp_name || ev.comp_name || ""}</td>
                                                  <td>{quarterLabel(ev.quarter)}</td>
                                                  <td>{ev.year}</td>
                                                  <td>{ev.centre}</td>
                                                  <td>{ev.total_points}</td>
                                                  <td>{ev.is_submitted === 'Y' ? 'Yes' : 'No'}</td>
                                                  <td className="action-btns">
                                                       <button type="button" className="icon-btn" title="View" onClick={() => navigate(`/view-self-evaluations/${ev.id}`)}>
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                 <path d="M12 5C7 5 2.7 8.11 1 12c1.7 3.89 6 7 11 7s9.3-3.11 11-7c-1.7-3.89-6-7-11-7z" stroke="#222" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                 <circle cx="12" cy="12" r="3" stroke="#222" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                       </button>
                                                       {ev.is_submitted !== 'Y' && (
                                                            <button type="button" className="icon-btn" title="Edit" onClick={() => navigate(`/edit-self-evaluations/${ev.id}/edit`)}>
                                                                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                      <path d="M3 21v-3.6l11-11L20.6 9 9.6 20H3z" stroke="#0a66ff" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                      <path d="M14 6l4 4" stroke="#0a66ff" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                                 </svg>
                                                            </button>
                                                       )}
                                                       {/* <button type="button" className="icon-btn" title="Delete" onClick={() => handleDelete(ev.id)}>
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                 <path d="M3 6h18" stroke="#c32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                 <path d="M8 6V4h8v2" stroke="#c32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                 <path d="M10 11v6" stroke="#c32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                 <path d="M14 11v6" stroke="#c32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                       </button> */}
                                                  </td>
                                             </tr>
                                        ))}
                                   </tbody>
                              </table>

                              <div className="pagination">
                                   <div className="page-info">Showing {Math.min((currentPage - 1) * pageSize + 1, evaluations.length)} - {Math.min(currentPage * pageSize, evaluations.length)} of {evaluations.length}</div>
                                   <button type="button" className="page-btn" onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>First</button>
                                   <button type="button" className="page-btn" onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>Prev</button>
                                   <button type="button" className="page-btn" onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>Next</button>
                                   <button type="button" className="page-btn" onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>Last</button>
                              </div>
                         </>
                    )}
               </div>
          </div>
     );
}
